import {NgModule} from '@angular/core';
import {ApplicationStatusComponent} from './application-status.component';
import {ApplicationStatusRoutingModule} from './application-status-routing.module';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {ProgressBarModule} from '../../views/common/progress-bar/progress-bar.module';
import {LoanApplicationProgressFactory} from './loan-application-progress.factory';

@NgModule({
    declarations: [ApplicationStatusComponent],
    imports: [CommonSectionsModule, ApplicationStatusRoutingModule, ProgressBarModule],
    providers: [LoanApplicationProgressFactory]
})
export class ApplicationStatusModule {
}
